import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../redux/UserActions";
import { API_URL } from "../redux/constants";
import {
  editProfile,
  kickUsers,
  organizationUsers,
  registerUser,
  organizationData,
} from "../redux/UserActions";
import { NavLink } from "react-router-dom";
import ListBox from "./Helper/ListBox";
import UserRegister from "./User/UserRegisterForm";
import readXlsxFile from "read-excel-file";

function UserManagement() {
  const dispatch = useDispatch();

  const userSelector = useSelector((state) => state.user);

  const [selected, setSelected] = useState([]);

  const [deleteSelected, setDelete] = useState([]);

  const [edit, setEdit] = useState(null);

  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const [selectedRole, setSelectedRole] = useState(
    userSelector.users[selected[0]]?.role
  );
  const [selectedPosition, setSelectedPosition] = useState(
    userSelector.users[selected[0]]?.position
  );

  const [filteredUsers, setFilteredUsers] = useState([]);

  const [newUser, setNewUser] = useState({
    FirstName: "",
    LastName: "",
    Mail: "",
    CountryCode: "",
    PhoneNumber: "",
    Organization: userSelector.invitationCode,
    Points: 0,
    GiftRequests: [],
    MoodRequested: false,
    Password: "",
  });

  const columns = [
    { name: "Name", filter: "name" },
    { name: "Age Group", filter: "age" },
    { name: "Department", filter: "department" },
    { name: "Location", filter: "location" },
    { name: "Phone Number", filter: "phoneNumber" },
    { name: "Role", filter: "role" },
    { name: "Activity", filter: "activity" },
  ];

  const ageGroups = ["10 - 18", "19 - 30", "31 - 45", "45 - 55", "55+"];

  const [rows, setRows] = useState([]);

  function selectionChange(selected_rows) {
    setDelete(selected_rows);
  }

  useEffect(() => {
    setFilteredUsers(userSelector.users);
  }, [userSelector.users]);

  useEffect(() => {
    dispatch(UserActions.organization({}));
    dispatch(UserActions.users({}));
  }, []);

  // useEffect(() => { console.log(selectedRole, selectedPosition) }, [selectedRole, selectedPosition])

  function filterTable(tex, fil) {
    const e = tex.replace(/\s+/g, "").toLowerCase();
    if (e != "") {
      const table_rows = [];
      userSelector.organizationUsers.map((user) => {
        switch (fil) {
          case "name":
            if (
              (user.firstName + " " + user.lastName)
                .replace(/\s+/g, "")
                .toLowerCase()
                .includes(e)
            ) {
              table_rows.push(user);
            }
            break;
          case "age":
            if (
              String(ageGroups[user.age])
                .replace(/\s+/g, "")
                .toLowerCase()
                .includes(e)
            ) {
              table_rows.push(user);
            }
            break;
          case "position":
            if (
              String(user.position)
                .replace(/\s+/g, "")
                .toLowerCase()
                .includes(e)
            ) {
              table_rows.push(user);
            }
            break;
          case "phoneNumber":
            if (
              ("+" + user.countryCode + user.phoneNumber)
                .replace(/\s+/g, "")
                .toLowerCase()
                .includes(e)
            ) {
              table_rows.push(user);
            }
            break;
          case "role":
            if (user.role.replace(/\s+/g, "").toLowerCase().includes(e)) {
              table_rows.push(user);
            }
            break;
          case "points":
            if (
              String(user.points).replace(/\s+/g, "").toLowerCase().includes(e)
            ) {
              table_rows.push(user);
            }
            break;
        }
      });
      setFilteredUsers(table_rows);
    } else {
      setFilteredUsers(userSelector.users);
    }
  }

  function setUserRole(person, role) {
    dispatch(
      editProfile({
        ID: person._id["$oid"],
        role: role,
      })
    );
  }

  function setUserPosition(person, position) {
    dispatch(
      editProfile({
        ID: person._id["$oid"],
        department: position,
      })
    );
  }

  function setUserLocation(person, position) {
    dispatch(
      editProfile({
        ID: person._id["$oid"],
        location: position,
      })
    );
  }

  function regUser() {
    if (
      newUser.FirstName === "" ||
      newUser.LastName === "" ||
      newUser.Mail === "" ||
      newUser.PhoneNumber === ""
    ) {
      alert("All Fields Are Required");
    } else {
      const [countryCode, phoneNumber] = newUser.PhoneNumber.split("-");

      dispatch(
        registerUser({
          ...newUser,
          PhoneNumber: phoneNumber.replace(" ", "").replace("-", ""),
          CountryCode: countryCode.replace(" ", "").replace("-", ""),
        })
      );
    }
  }

  function clickUpload() {
    const input = document.getElementById("fileInput");
    input.click();
  }

  function registerMany() {
    const input = document.getElementById("fileInput");
    readXlsxFile(input.files[0]).then((rows) => {
      rows.map((rw, idx) => {
        if (idx !== 0 && idx !== 1 && idx !== 2) {
          dispatch(
            registerUser({
              firstName: rw[0],
              lastName: rw[1],
              mail: rw[2],
              organization: userSelector.organization.code,
            })
          );
        }
      });
    });
  }

  return (
    <div className="flex flex-col w-full py-2 align-middle shadow border-b border-gray-200 sm:rounded-lg">
      <div className="mx-2 h-14 grid grid-cols-7 text-right">
        <button
          className="col-start-5 mx-2 bg-green-600 hover:bg-green-900 m-2 text-white rounded shadow md:text-sm"
          onClick={() => setShowAddUserModal(!showAddUserModal)}
        >
          Create User
        </button>
        <a
          className="flex-initial m-2 mx-2"
          href="//static.wellm8.com/templates/Template.xlsx"
          download={true}
        >
          <button className="w-full h-full bg-blue-600 hover:bg-blue-900 text-white rounded shadow">
            Download Excel Template
          </button>
        </a>
        <input
          id="fileInput"
          className="hidden"
          placeholder="FILE"
          type="file"
          onChange={(e) => registerMany()}
        />
        <button
          className="mx-2 bg-green-600 hover:bg-green-900 m-2 text-white rounded shadow"
          onClick={(e) => clickUpload()}
        >
          Import Users
        </button>
      </div>
      <table className="table-auto w-full mr-20 divide-y divide-gray-200">
        <thead className="bg-gray-50 w-full">
          <tr>
            {columns.map((column) => (
              <th
                scope="col"
                className="py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {column.name}
                <br></br>
                <input
                  className="mx-auto border-gray-300 rounded-md h-5"
                  autoComplete="off"
                  type="text"
                  id={column.filter}
                  onChange={(e) => filterTable(e.target.value, column.filter)}
                ></input>
              </th>
            ))}
            <th scope="col" className="relative px-6 py-3">
              Options
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white w-full divide-y divide-gray-200">
          {filteredUsers.map((person) =>
            person._id["$oid"] === userSelector.user._id ? null : (
              <tr key={String(person._id["$oid"])}>
                <td className="py-4 whitespace-nowrap">
                  <div className="flex items-left">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full object-cover"
                        src={
                          person.profilePicture
                            ? API_URL +
                              "image/profile/" +
                              String(person._id.$oid)
                            : "https://t4.ftcdn.net/jpg/00/64/67/63/360_F_64676383_LdbmhiNM6Ypzb3FM4PPuFP9rHe7ri8Ju.jpg"
                        }
                        alt=""
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm text-left font-medium text-gray-900">
                        {person.firstName + " " + person.lastName}
                      </div>
                      <div className="text-sm text-left ml-2 text-gray-500">
                        {person.mail}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-center text-gray-500">
                    {ageGroups[person.age]}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
                  <ListBox
                    options={userSelector.organization.departments}
                    current={person.department}
                    _handleSelected={(e) => setUserPosition(person, e)}
                  />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
                  <ListBox
                    options={userSelector.organization.locations}
                    current={person.location}
                    _handleSelected={(e) => setUserLocation(person, e)}
                  />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                  {"+" + person.countryCode + " " + person.phoneNumber}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-left text-sm text-gray-500">
                  <ListBox
                    options={["Admin", "Support", "User"]}
                    current={person.role}
                    _handleSelected={(e) => setUserRole(person, e)}
                  />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                  {person.active}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                  <NavLink
                    to={"/reset_password_admin/" + person.mail}
                    className="text-indigo-600 hover:text-indigo-900"
                  >
                    Reset Password
                  </NavLink>
                  <button
                    id={"delete-" + person.mail}
                    className="mx-2 bg-red-600 hover:bg-red-900 text-white p-2 rounded shadow"
                    onClick={() => {
                      document
                        .getElementById("confirm-" + person.mail)
                        .classList.remove("hidden");
                      document
                        .getElementById("delete-" + person.mail)
                        .classList.add("hidden");
                    }}
                  >
                    Archive User
                  </button>
                  <button
                    id={"confirm-" + person.mail}
                    className="hidden mx-2 bg-red-600 hover:bg-red-900 text-white p-2 rounded shadow"
                    onClick={() => {
                      dispatch(kickUsers({ id: person._id["$oid"] }));
                    }}
                  >
                    Confirm Archive
                  </button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
      <UserRegister
        isOpen={showAddUserModal}
        setIsOpen={setShowAddUserModal}
        _handleRegister={(e) => regUser(e)}
      />
    </div>
  );
}

export default UserManagement;
